import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import GooglePlaceAutocompleteInput from "../GooglePlaceAutocompleteInput";

const signInTrackingRegisterEnum = {
    home_upnest_product_home_upnest_product_get_started: 'home_upnest_product_home_upnest_product_get_started',
    click_home_upnest_product_home_seller: 'click_home_upnest_product_home_seller',
    click_home_upnest_product_click_enter_location_form: 'click_home_upnest_product_click_enter_location_form',
    search_homepage_upnest_product_compare_agents: 'search_homepage_upnest_product_compare_agents',
    click_home_upnest_product_compare_agents: 'click_home_upnest_product_compare_agents',
    click_home_upnest_product_home_buyer: 'click_home_upnest_product_home_buyer',
    click_home_upnest_product_agent: 'click_home_upnest_product_agent',
    search_homepage_upnest_product_home_buyer_compare_agents: 'search_homepage_upnest_product_home_buyer_compare_agents',
};

function signInTrackingRegisterFireEvent({ event }, params = {}) {
    if(typeof window.UpNestAnalytics != 'undefined' && window.UpNestAnalytics != null) {
        switch(event) {
            case signInTrackingRegisterEnum.home_upnest_product_home_upnest_product_get_started:
                // [::TRACK][Sign+In+Pageview] Pageview selecting product
                UpNestAnalytics.trackPage("home:upnest_product", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:get_started",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.click_home_upnest_product_home_seller:
                // [::TRACK][Sign+In+Pageview] Click on the Home Seller button
                UpNestAnalytics.trackEvent("click", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:home_seller",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.click_home_upnest_product_click_enter_location_form:
                // [::TRACK][Sign+In+Pageview] Click on the Home Seller button :: Click on the search form to enter a location
                UpNestAnalytics.trackEvent("click", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:click_enter_location_form",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.search_homepage_upnest_product_compare_agents:
                // [::TRACK][Sign+In+Pageview] Click on the Home Seller button :: Click on the search form to enter a location
                UpNestAnalytics.trackEvent("search", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "homepage:upnest_product:compare_agents",
                    // searchCategory: "<recent, place, city, postal_code, county>",
                    // searchQuery: "<Collects anything user types in searchbox, selects from search box or is selected for them>",
                    // searchType: "<city, pan, gps, county, zip_code>",
                    // searchUserEnteredText: "<Text user entered to search>",
                    pageType: "upnest_product",
                    siteSection: "home",
                    ...(params || {}),
                });
                break;
            case signInTrackingRegisterEnum.click_home_upnest_product_compare_agents:
                // [::TRACK][Sign+In+Pageview] Click on the Home Seller button :: -
                UpNestAnalytics.trackEvent("click", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:compare_agents",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.click_home_upnest_product_home_buyer:
                // [::TRACK][Sign+In+Pageview] Buyer Flow Events :: click on the home buyer button
                UpNestAnalytics.trackEvent("click", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:home_buyer",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.click_home_upnest_product_agent:
                // [::TRACK][Sign+In+Pageview] Buyer Flow Events :: Click on the agent button
                UpNestAnalytics.trackEvent("click", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "home:upnest_product:agent",
                    pageType: "upnest_product",
                    siteSection: "home",
                });
                break;
            case signInTrackingRegisterEnum.search_homepage_upnest_product_home_buyer_compare_agents:
                // [::TRACK][Sign+In+Pageview] Buyer Flow Events :: Search event after clicking the
                UpNestAnalytics.trackEvent("search", {
                    pageId: "upnest_product",
                    pageName: "home:upnest_product",
                    linkName: "homepage:upnest_product:home_buyer:compare_agents",
                    // searchCategory: "<recent, place, city, postal_code, county>",
                    // searchQuery: "<Collects anything user types in searchbox, selects from search box or is selected for them>",
                    // searchType: "<city, pan, gps, county, zip_code>",
                    // searchUserEnteredText: "<Text user entered to search>",
                    pageType: "upnest_product",
                    siteSection: "home",
                    ...(params || {}),
                });
                break;
        }
    }
}

const activeTab = Object.freeze({
    SELLER: 'SELLER',
    BUYER: 'BUYER',
    AGENT: 'AGENT'
});

class BuyerImg extends Component {
    imagePath = global.brandSlug != null && global.brandSlug != "" ? global.whitelabelImageBaseUrl + 'img/register_buyer.svg' : 'img/register/buyer.svg';

    render() {
        return (
            <img src={this.imagePath}/>
        );
    }
}

class SellerImg extends Component {
    imagePath = global.brandSlug != null && global.brandSlug != "" ? global.whitelabelImageBaseUrl + 'img/register_seller.svg' : 'img/register/seller.svg';

    render() {
        return (
            <img src={this.imagePath}/>
        );
    }
}

class AgentImg extends Component {
    imagePath = global.brandSlug != null && global.brandSlug != "" ? global.whitelabelImageBaseUrl + 'img/register_agent.svg' : 'img/register/agent.svg';

    render() {
        return (
            <img src={this.imagePath}/>
        );
    }
}

export default class Register extends Component {
    static get propTypes() {
        return {
            kw: PropTypes.string,
            campaign: PropTypes.string
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            selected: null,
            activeInput: false,
            user_input: '',
            location: '',
            locationError: false
        };
    }

    componentDidMount() {
        signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.home_upnest_product_home_upnest_product_get_started });
    }

    onSubmitSearchForm = event => {
        if (!this.state.location || !/(['a-zA-Z ]+,\s*[a-zA-Z].*|\b\d{5}\b)/.test(this.state.location)) {
            this.setState({locationError: true});
            event.preventDefault();
        } else {
            const query = this.state.location;
            const user_input = this.state.user_input;

            const search_category = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(query) ? 'postal_code' : 'city';
            const search_type = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(query) ? 'zip_code' : 'city';

            this.state.selected == activeTab.SELLER
                && signInTrackingRegisterFireEvent({
                    event: signInTrackingRegisterEnum.search_homepage_upnest_product_compare_agents,
                }, {
                    searchCategory: search_category,
                    searchQuery: query,
                    searchType: search_type,
                    searchUserEnteredText: user_input,
                });

            this.state.selected == activeTab.BUYER
                && signInTrackingRegisterFireEvent({
                    event: signInTrackingRegisterEnum.search_homepage_upnest_product_home_buyer_compare_agents,
                }, {
                    searchCategory: search_category,
                    searchQuery: user_input,
                    searchType: search_type,
                    searchUserEnteredText: user_input,
                });

            var personaType = this.state.selected == activeTab.BUYER ? 'buyer' : 'seller' ;
            ga('send', 'event', 'signUpFlow', 'personaSelection_' + personaType, 'user selected to be ' + personaType);
            trackEvent('registerSearchSubmit', 'sellerReceivedQuotes', 'User submitted search form on register page', {
                'lastEvent': 'registerSearchSubmit',
                'userType': userType
            }).withGA().withOptimizely();
        }
    };

    onClickCompareAgents = () => {
        signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.click_home_upnest_product_compare_agents });
    }

    render() {
        const {selected, activeInput, location, locationError} = this.state;
        const {kw, campaign} = this.props;

        return (
            <div className="user-register">

                <div className="container-fluid text-center" id="userRegister">
                    <div className="register-container">
                        <div className="register-section pickUserType">
                            <div className="pickUserOuter">
                                <div className="pickUserInner">
                                    <div className="pickUserTitle">
                                        <h4>Sign Up {global.brandSlug ? '' : 'with UpNest'}</h4>
                                    </div>
                                    <div className="pickUserSelect">
                                        <ul className="pickUserSelectList clearfix">
                                            <li className={"UserBox" + (selected == activeTab.SELLER ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({selected: activeTab.SELLER, locationError: false});
                                                    signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.click_home_upnest_product_home_seller });
                                                }}>
                                                <a className="pickUserSelectType" data-client-type="seller">
                                                    <div className="pickUserSelectContainer">
                                                        <SellerImg/>
                                                    </div>
                                                    <p className="pickUserTypeDescription">I am <span className="hide-desktop">a </span><span className="next-line">Home Seller</span></p>
                                                </a>
                                            </li>
                                            <li className={"UserBox" + (selected == activeTab.BUYER ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({selected: activeTab.BUYER, locationError: false});
                                                    signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.click_home_upnest_product_home_buyer });
                                                }}>
                                                <a className="pickUserSelectType" data-client-type="buyer">
                                                    <div className="pickUserSelectContainer">
                                                        <BuyerImg/>
                                                    </div>
                                                    <p className="pickUserTypeDescription">I am <span className="hide-desktop">a </span><span className="next-line">Home Buyer</span></p>
                                                </a>
                                            </li>
                                            <li className={"UserBox" + (selected == activeTab.AGENT ? ' selected' : '')}
                                                onClick={() => {
                                                    this.setState({selected: activeTab.AGENT, locationError: false});
                                                    signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.click_home_upnest_product_agent });
                                                    ga('send', 'event', 'signUpFlow', 'personaSelection_agent', 'user selected to be agent',{nonInteraction:true});
                                                    window.location='agent-signup?join=true';
                                                }}>
                                                <a href="javascript:void(0)" className="pickUserSelectType" data-client-type="agent">
                                                    <div className="pickUserSelectContainer">
                                                        <AgentImg/>
                                                    </div>
                                                    <p className="pickUserTypeDescription">I am <span className="next-line">an Agent</span></p>
                                                </a>
                                            </li>
                                        </ul>

                                        {(selected == activeTab.SELLER || selected == activeTab.BUYER) && (
                                            <div className="register-section search-bar">
                                                <form className="search-form" action="create-draft-request2" method="GET"
                                                    onSubmit={this.onSubmitSearchForm}>
                                                    <GooglePlaceAutocompleteInput
                                                        name="location"
                                                        className={"required forminput location-input" + (activeInput ? " active" : "")}
                                                        type="text"
                                                        value={location}
                                                        autocompleteOptions={{
                                                            types: ['(cities)'],
                                                            componentRestrictions: {country: 'us'}
                                                        }}
                                                        placeholder={"City and State, or ZIP"}
                                                        onClick={() => {
                                                            selected == activeTab.SELLER && signInTrackingRegisterFireEvent({ event: signInTrackingRegisterEnum.click_home_upnest_product_click_enter_location_form });
                                                        }}
                                                        onInput={({target: {value}}) => {
                                                            console.log('onInput');
                                                            value = value.replace(/\s*,\s*(USA|United States)$/, '');
                                                            this.setState({
                                                                user_input: value,
                                                                location: value,
                                                                activeInput: true
                                                            });
                                                        }}
                                                        onPlaceChanged={(input, place) => {
                                                            window.placex = place

                                                            input.value = input.value.replace(/\s*,\s*(USA|United States)$/, '');
                                                            this.setState({
                                                                location: input.value,
                                                                activeInput: true
                                                            });
                                                            $(input).trigger('focusout');
                                                        }}
                                                        spellCheck/>
                                                    <input type="hidden" name="dlink" value="true"/>
                                                    <input type="hidden" name="from" value="<s:url/>"/>
                                                    {kw && (
                                                        <input type="hidden" name="kw" value={kw}/>
                                                    )}
                                                    {campaign && (
                                                        <input type="hidden" name="campaign" value={campaign}/>
                                                    )}
                                                    <input type="hidden" name="source" value="personaFlow"/>
                                                    <input type="hidden" value={true}
                                                        name={selected == activeTab.SELLER ? "seller" : "buyer"}/>
                                                    <input type="hidden" name="requestType"
                                                        value={selected == activeTab.SELLER ? "sell" : "buy"}/>
                                                    <button className="btn btn-default search-button" onClick={this.onClickCompareAgents}>Compare Agents</button>
                                                </form>
                                                {locationError && (
                                                    <p className="error">Please enter a city and state separated by a comma or a 5-digit ZIP code.</p>
                                                )}
                                            </div>
                                        )}

                                        {/* <div className="toLoginPage">
                                            <div><span className="toLoginPageTitle">Already have an account?<a className="toLoginPageLink" href="login"> Log in here.</a></span></div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}
